import { useInfiniteQuery, useQuery, useQueryClient } from "react-query";
import { useAvailabilityAndPricingApi } from "./useAvailabilityAndPricingApi";
import { useEffect, useMemo, useRef } from "react";

const queryKeys = {
    dailyPrices: ["dailyPrices"],
    dailyAvailability: ["dailyAvailability"],
    dailyAvailabilityAndPrices: ["dailyAvailabilityAndPrices"],
    latestCheckoutDate: ["latestCheckoutDate"],
    totalPrice: ["totalPrice"],
};

export const useDailyAvailabilityData = (propertyId, roomId, from, to, enabled = true) => {
    const { getDailyAvailability } = useAvailabilityAndPricingApi();

    const queryResults = useQuery({
        queryKey: [...queryKeys.dailyAvailability, propertyId, roomId, from, to],
        queryFn: () => getDailyAvailability(propertyId, roomId, from, to),
        cacheTime: 0,
        staleTime: 0,
        enabled: !!propertyId && !!roomId && !!from && !!to && enabled,
    });

    return {
        queryResults,
    };

};

export const useDailyAvailabilityAndPrices = (propertyId, roomId, defaultFrom, defaultTo, enabled = true) => {
    const { getDailyAvailabilityAndPrices } = useAvailabilityAndPricingApi();

    const prevFromDate = useRef();

    const queryClient = useQueryClient();
    const prevFromQueryKey = useMemo(() => [...queryKeys.dailyAvailabilityAndPrices, { propertyId, roomId: roomId, fromDate: prevFromDate.current }], [propertyId, roomId, defaultFrom]);// eslint-disable-line react-hooks/exhaustive-deps
    const prevQueryData = useMemo(() => queryClient.getQueryData(prevFromQueryKey), [prevFromQueryKey]);// eslint-disable-line react-hooks/exhaustive-deps

    const queryConfig = {
        queryKey: [...queryKeys.dailyAvailabilityAndPrices, { propertyId, roomId: roomId, fromDate: defaultFrom }],
        queryFn: ({ pageParam = { from: defaultFrom, to: defaultTo } }) => {
            return getDailyAvailabilityAndPrices(propertyId, roomId, pageParam.from, pageParam.to);
        },
        getNextPageParam: (lastPage) => {
            const { to } = lastPage;

            const nextFrom = new Date(to.toDateString());
            nextFrom.setDate(nextFrom.getDate() + 1);

            const nextTo = new Date(nextFrom.toDateString());
            nextTo.setDate(nextTo.getDate() + 45);

            return { from: nextFrom, to: nextTo };
        },
        cacheTime: 0,
        staleTime: 0,
        placeholderData: prevQueryData,
        enabled: !!propertyId && !!roomId && !!defaultFrom && !!defaultTo && enabled,
    }

    useEffect(() => {
        prevFromDate.current = defaultFrom;
    }, [defaultFrom]);

    const queryResults = useInfiniteQuery({
        ...queryConfig,
    });

    return {
        queryResults,
    }
}

